export enum StoreEnums {
  stores = 'Store/Stores', // 取得店家資訊清單
  storesV2 = 'v2/Store/Stores', // 新系統：取得店家資訊清單
  storesUnderMyOwn = 'Store/StoresDDL', // 可用店家(只取自己名下的店家)
  storesOnOtherPool = 'Store/OnOtherPoolStoresDDL', // 可用店家(其他店主底下的可用店家)
  add = 'Store/Add', // 新增店家資訊
  update = 'Store/Update', // 更新店家資訊
  disable = 'Store/Disable', // 停用店家資訊
  recordCurrentStore = 'Store/RecordCurrentStore', // 暫存目前點選的店家
  changeStoreGroup = 'Store/ChangeStoreGroup', // 變更店家群組
  updateStoreTimeZone = 'Store/UpdateStoreTimeZone', // 更新店家結帳時區
  getStoreTimeZoneModifyRecord = 'Store/GetStoreTimeZoneModifyRecord', // 取得店家結帳時區修改記錄
  getStoreTimeZone = 'Store/GetStoreTimeZone', // 取得店家當前時區設定
  getAccountTimezones = 'Store/GetAggregatedDistinctTimezonesForStoresOfThisAccount', // 取得此帳號底下所有店家的時區清單
  storeMetricThreshold = 'Store/store-metric-threshold', // 取得/更新店家指標門檻設定
  // 新系統：一次取得此帳號底下所有店家的營運分析與風險警示計數（2026-09-10 契約整併，
  // 原本的 stores-operations-alert 已下架）；timeZoneId 必填，useMockData 為後端假資料開關
  storeOperationsAnalytics = 'v2/Store/operations-analytics',

  // 帳務異常判定與帳目修正（OP#1855）。資料為事件層級，以 (egmId, goodsId, occurredAt)
  // 定位；egmId 即前端的 pcbId。storeId 由後端自登入資訊取得，前端不送
  accountingAdjustmentRecord = 'v2/Store/accounting-adjustment/record-v2', // MI 計算過的每事件 delta
  accountingAdjustmentAbnormal = 'v2/Store/accounting-adjustment/abnormal-by-system-v2', // 系統偵測的異常事件
  // 修正紀錄。GET 取得歷程；POST 新增修正，異常的接受／拒絕／撤銷也走這支，
  // 以 operateType 區分，沒有獨立端點
  accountingAdjustmentCorrection = 'v2/Store/accounting-adjustment/correction-v2',
  // 異常帳目的判定（接受／拒絕／撤銷），與上面查詢用的 abnormal-by-system-v2 是不同端點
  accountingAdjustmentAbnormalDecision = 'v2/Store/accounting-adjustment/abnormal-v2'
}
